import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import ClientManagerService from '../services/ClientManager/clientManager.service';
import type { SubscriptionType } from '../types/ClientManagementTypes';
import type { SubscriptionTier } from '../enums/clientEnums';

export const useSubscriptionTypes = () => {
  const { getSubscriptionTypes } = ClientManagerService();
  const { data, isLoading, isLoadingError } = useQuery(getSubscriptionTypes());

  const subscriptionTypes = useMemo(() => data ?? [], [data]);

  // Keyed lookup: every tier label and the plan popover resolve a plan by wire id.
  const subscriptionTypesById = useMemo(
    () => new Map<SubscriptionTier, SubscriptionType>(subscriptionTypes.map((type) => [type.id, type])),
    [subscriptionTypes],
  );

  return {
    subscriptionTypes,
    subscriptionTypesById,
    isLoadingSubscriptionTypes: isLoading,
    isSubscriptionTypesLoadingError: isLoadingError,
  };
};
